import { render } from "./VabeneIngredientList.vue?vue&type=template&id=2cae1d28&ts=true"
import script from "./VabeneIngredientList.vue?vue&type=script&lang=ts"
export * from "./VabeneIngredientList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__